import { clsx } from 'clsx'
import { type FC } from 'react'

import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { ProductDiscount } from '../../../../product'

type ProductDiscountBadgeProps = {
  className?: string
  currentPrescriptionType: PrescriptionV3PrescriptionTypeEnum
  'data-qa-id'?: string
  discount: number
  isDiscountValid: boolean
  showThirtyDaysPrice: boolean
}

export const ProductDiscountBadge: FC<ProductDiscountBadgeProps> = ({
  className,
  currentPrescriptionType,
  'data-qa-id': dataQaId,
  discount,
  isDiscountValid,
  showThirtyDaysPrice,
}) => {
  const { superScripts } = useGlobalConfigContext()

  if (
    currentPrescriptionType ===
    PrescriptionV3PrescriptionTypeEnum.NoPrescription
  ) {
    if (!discount || !isDiscountValid) {
      return null
    }

    return (
      <ProductDiscount
        className={clsx(
          'rounded-full bg-light-tertiary font-mono text-xs font-medium',
          className,
        )}
        data-qa-id={dataQaId}
        discount={priceGetFormattedPercentageDiscount(discount)}
        supNote={
          showThirtyDaysPrice
            ? superScripts.discountThirtyDays
            : superScripts.supNoteNumber
        }
      />
    )
  }

  return null
}
